import SubscribersList from '../../admin/pages/Subscribers/List'

export default [
    {
        path: 'subscribers',
        name: 'subscribe-list',
        component: SubscribersList,
    }
]
